// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 220px;
  background-color: #fff;
  border-right: 1px solid rgba(255, 255, 255, 0.959);
  padding: 0px;
  direction: ltr;
  transition: left 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  z-index: 5555;
}
.sidebar .link-container {
  position: relative;
  width: 100%;
  height: 85vh;
  overflow: auto;
}
.sidebar .logo {
  padding: 5px 15px 0;
  margin-bottom: 0px;
  position: relative;
  justify-content: space-between;
}
.sidebar .logo h3 {
  margin: 0;
  color: #0f7f3d;
  font-weight: 800;
}
.sidebar .logo img {
  width: 50px;
  display: inline-block;
}
.sidebar .pages {
  padding: 0px 15px;
}
.sidebar .pages p {
  font-size: 15px;
  margin-bottom: 5px;
  font-weight: bold;
  color: var(--mainFont);
}
.sidebar .pages div {
  margin-bottom: 10px;
  position: relative;
}
.sidebar .pages div .unseenComplains {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 10px;
  top: 5px;
  width: 20px;
  height: 20px;
  background-color: #0f7f3d;
  border-radius: 50%;
  z-index: 55;
  color: #fff;
}
.sidebar .pages div .link {
  display: block;
  text-decoration: none;
  color: var(--mainFont);
  padding: 5px 10px;
  width: 100%;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  font-size: 14px;
}
.sidebar .pages div .link img {
  width: 18px;
}
.sidebar .pages div .link span {
  margin-left: 10px;
}
.sidebar .pages div .link svg {
  margin-left: 5px;
}
.sidebar .pages div .link svg path {
  fill: var(--mainFont);
}
.sidebar .pages div .link:hover {
  padding-left: 20px;
}
.sidebar .pages div .active {
  background-image: var(--linkActive);
  color: #fff !important;
  box-shadow: var(--linkshadow);
  opacity: 1 !important;
}
.sidebar .pages div .active svg path {
  fill: #fff !important;
}
.sidebar .close {
  display: none;
}
.sidebar .close svg path {
  fill: var(--headerFont);
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  visibility: hidden;
  opacity: 0;
  z-index: 66;
  background-color: rgba(0, 0, 0, 0.473);
  transition: all 0.5s ease;
  z-index: 5554;
}

.rtl .sidebar {
  right: 0;
  left: unset;
}
.rtl .sidebar .pages,
.rtl .sidebar .logo {
  direction: rtl;
}
.rtl .sidebar .link span {
  margin-right: 10px;
}
.rtl .sidebar .link:hover {
  padding-right: 20px;
}
.rtl .sidebar .logo img {
  margin-right: 0;
  margin-left: 15px;
}
.rtl .sidebar .logo i {
  left: 0;
  right: unset;
}

.dark .sidebar {
  background-color: var(--darkSecondColor);
  border-right: 1px solid var(--darkSecondColor);
}
.dark .sidebar .pages div .link {
  color: var(--darkFont);
}
.dark .sidebar .pages div .link svg path {
  fill: var(--darkFont);
}
.dark .sidebar .logo h3 {
  color: #fff !important;
}

@media (max-width: 1000px) {
  .sidebar {
    left: -240px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }
  .sidebar .close {
    display: block;
    position: absolute;
    right: 10px;
    cursor: pointer;
  }
  .openSideBar {
    left: 0 !important;
  }
  .rtl .sidebar {
    left: unset !important;
    right: -240px !important;
  }
  .rtl .openSideBar {
    right: 0 !important;
  }
  .rtl .close {
    display: block;
    position: absolute;
    left: 10px !important;
    right: unset;
    cursor: pointer;
  }
  .openOverlay {
    visibility: visible;
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Sidebar/sideBar.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kDAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,aAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAEJ;AAAE;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;AAEJ;AADI;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AAGN;AADI;EACE,WAAA;EACA,qBAAA;AAGN;AAAE;EACE,iBAAA;AAEJ;AADI;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAGN;AADI;EACE,mBAAA;EACA,kBAAA;AAGN;AAFM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAIR;AAFM;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,eAAA;AAIR;AAHQ;EACE,WAAA;AAKV;AAHQ;EACE,iBAAA;AAKV;AAHQ;EACE,gBAAA;AAKV;AAJU;EACE,qBAAA;AAMZ;AAFM;EACE,kBAAA;AAIR;AAFM;EACE,mCAAA;EACA,sBAAA;EACA,6BAAA;EACA,qBAAA;AAIR;AAFU;EACE,qBAAA;AAIZ;AAEE;EACE,aAAA;AAAJ;AAEM;EACE,uBAAA;AAAR;;AAKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;EACA,yBAAA;EACA,aAAA;AAFF;;AAKE;EACE,QAAA;EACA,WAAA;AAFJ;AAGI;;EAEE,cAAA;AADN;AAIM;EACE,kBAAA;AAFR;AAKI;EACE,mBAAA;AAHN;AAMM;EACE,eAAA;EACA,iBAAA;AAJR;AAMM;EACE,OAAA;EACA,YAAA;AAJR;;AAUE;EACE,wCAAA;EACA,8CAAA;AAPJ;AAQI;EACE,sBAAA;AANN;AAQQ;EACE,qBAAA;AANV;AAWM;EACE,sBAAA;AATR;;AAcA;EACE;IACE,YAAA;IACA,gDAAA;EAXF;EAYE;IACE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;EAVJ;EAaA;IACE,kBAAA;EAXF;EAcE;IACE,sBAAA;IACA,wBAAA;EAZJ;EAcE;IACE,mBAAA;EAZJ;EAcE;IACE,cAAA;IACA,kBAAA;IACA,qBAAA;IACA,YAAA;IACA,eAAA;EAZJ;EAeA;IACE,mBAAA;IACA,UAAA;EAbF;AACF","sourcesContent":[".sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 220px;\n  background-color: #fff;\n  border-right: 1px solid rgba(255, 255, 255, 0.959);\n  padding: 0px;\n  direction: ltr;\n  transition: left 0.3s ease-in-out;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  z-index: 5555;\n  .link-container {\n    position: relative;\n    width: 100%;\n    height: 85vh;\n    overflow: auto;\n  }\n  .logo {\n    padding: 5px 15px 0;\n    margin-bottom: 0px;\n    position: relative;\n    justify-content: space-between;\n    h3 {\n      margin: 0;\n      color: #0f7f3d;\n      font-weight: 800;\n    }\n    img {\n      width: 50px;\n      display: inline-block;\n    }\n  }\n  .pages {\n    padding: 0px 15px;\n    p {\n      font-size: 15px;\n      margin-bottom: 5px;\n      font-weight: bold;\n      color: var(--mainFont);\n    }\n    div {\n      margin-bottom: 10px;\n      position: relative;\n      .unseenComplains {\n        position: absolute;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        left: 10px;\n        top: 5px;\n        width: 20px;\n        height: 20px;\n        background-color: #0f7f3d;\n        border-radius: 50%;\n        z-index: 55;\n        color: #fff;\n      }\n      .link {\n        display: block;\n        text-decoration: none;\n        color: var(--mainFont);\n        padding: 5px 10px;\n        width: 100%;\n        border-radius: 5px;\n        -webkit-border-radius: 5px;\n        -moz-border-radius: 5px;\n        -ms-border-radius: 5px;\n        -o-border-radius: 5px;\n        transition: all 0.3s ease-out;\n        -webkit-transition: all 0.3s ease-out;\n        -moz-transition: all 0.3s ease-out;\n        -ms-transition: all 0.3s ease-out;\n        -o-transition: all 0.3s ease-out;\n        font-size: 14px;\n        img {\n          width: 18px;\n        }\n        span {\n          margin-left: 10px;\n        }\n        svg {\n          margin-left: 5px;\n          path {\n            fill: var(--mainFont);\n          }\n        }\n      }\n      .link:hover {\n        padding-left: 20px;\n      }\n      .active {\n        background-image: var(--linkActive);\n        color: #fff !important;\n        box-shadow: var(--linkshadow);\n        opacity: 1 !important;\n        svg {\n          path {\n            fill: #fff !important;\n          }\n        }\n      }\n    }\n  }\n  .close {\n    display: none;\n    svg {\n      path {\n        fill: var(--headerFont);\n      }\n    }\n  }\n}\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  visibility: hidden;\n  opacity: 0;\n  z-index: 66;\n  background-color: rgba(0, 0, 0, 0.473);\n  transition: all 0.5s ease;\n  z-index: 5554;\n}\n.rtl {\n  .sidebar {\n    right: 0;\n    left: unset;\n    .pages,\n    .logo {\n      direction: rtl;\n    }\n    .link {\n      span {\n        margin-right: 10px;\n      }\n    }\n    .link:hover {\n      padding-right: 20px;\n    }\n    .logo {\n      img {\n        margin-right: 0;\n        margin-left: 15px;\n      }\n      i {\n        left: 0;\n        right: unset;\n      }\n    }\n  }\n}\n.dark {\n  .sidebar {\n    background-color: var(--darkSecondColor);\n    border-right: 1px solid var(--darkSecondColor);\n    .pages div .link {\n      color: var(--darkFont);\n      svg {\n        path {\n          fill: var(--darkFont);\n        }\n      }\n    }\n    .logo {\n      h3 {\n        color: #fff !important;\n      }\n    }\n  }\n}\n@media (max-width: 1000px) {\n  .sidebar {\n    left: -240px;\n    border-right: 1px solid rgba(255, 255, 255, 0.3);\n    .close {\n      display: block;\n      position: absolute;\n      right: 10px;\n      cursor: pointer;\n    }\n  }\n  .openSideBar {\n    left: 0 !important;\n  }\n  .rtl {\n    .sidebar {\n      left: unset !important;\n      right: -240px !important;\n    }\n    .openSideBar {\n      right: 0 !important;\n    }\n    .close {\n      display: block;\n      position: absolute;\n      left: 10px !important;\n      right: unset;\n      cursor: pointer;\n    }\n  }\n  .openOverlay {\n    visibility: visible;\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
